(function () {
	window.gbg = window.gbg || {};
	gbg.StoryBook = (function () {

		let book = document.querySelector('.storybook-book');
		let markers = document.querySelector('.storybook-markers');
		let markersSettings = getComputedStyle(markers);
		let pages = book.getElementsByClassName('page');
		let innerPages = book.getElementsByClassName('page--inner');
		let angledImgs = document.querySelectorAll('.angled-img');
		let w = window.innerWidth;
		let autoTimer;
		let autoStep = w < 576 ? 1 : 2;
		let autoCounter = 0;
		let autoTimerInterval = markersSettings != null && markersSettings.getPropertyValue('--timing') != null ? markersSettings.getPropertyValue('--timing') * 1000 : 7000;

		for (var i = 0; i < pages.length; i++) {
			var page = pages[i];
			if (i % 2 === 0) {
				//page.style.zIndex = (pages.length - i);
				page.style.setProperty('--zi', pages.length - i);
			}
			else {
				page.style.setProperty('--zi', i + 1);
			}
		}

		let Init = function () {

			book = document.querySelector('.storybook-book');
			markers = document.querySelector('.storybook-markers');
			markersSettings = getComputedStyle(markers);
			pages = book.getElementsByClassName('page');
			innerPages = book.getElementsByClassName('page--inner');
			angledImgs = document.querySelectorAll('.row-angled-img');
			autoTimerInterval = markersSettings != null && markersSettings.getPropertyValue('--timing') != null ? markersSettings.getPropertyValue('--timing') * 1000 : 7000;

			for (let i = 0; i < pages.length; i++) {
				let page = pages[i];
				if (i % 2 === 0) {
					//page.style.zIndex = (pages.length - i);
					page.style.setProperty('--zi', pages.length - i);
				}
				else {
					page.style.setProperty('--zi', i + 1);
				}
			}

			if (false) {
				//ignore the first 2 and last 2 inner pages for clickability
				for (var i = 2; i < innerPages.length - 2; i++) {
					//Or var page = pages[i];
					innerPages[i].pageNum = i + 1;
					innerPages[i].onclick = function () {
						if (autoTimer) clearTimeout(autoTimer);
						if (this.pageNum % 2 === 0) {
							//setTimeout(removeFlipped, 350, this); 
							removeFlipped(this);
						}
						else {
							//setTimeout(addFlipped, 350, this);
							addFlipped(this);
						}
						//autoCounter = i - 2;
						autoTimer = setTimeout(autoTransition, autoTimerInterval);
					}
				}
			}

			setTimeout(openBook, 1000);

			let observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					entry.target.classList.add('row-angled-img--slide');
					if (entry.isIntersecting) {
						entry.target.classList.add('row-angled-img--vis');
						observer.unobserve(entry.target);
					}
				});
			}, {
				rootMargin: '-30%'
			});

			angledImgs.forEach(item => {
				observer.observe(item)
			});

		};

		let openBook = function () {
			let frontCover = document.querySelector('.page--front');
			addFlipped(frontCover);
			setTimeout(openFirstPage, 900);
		};

		let openFirstPage = function () {
			let firstPage = book.querySelectorAll('.page--inner');
			addFlipped(firstPage[0]);
			if (autoStep === 1) slideBook();
			autoTimer = setTimeout(autoTransition, autoTimerInterval);
			markers.className = 'storybook-markers storybook-markers--0';
		};

		let slideBook = function () {
			book.classList.toggle('storybook-book--alt');
		};

		let autoTransition = function () {
			autoCounter += autoStep;
			if (autoCounter >= innerPages.length - 2) {
				markers.className = 'storybook-markers';
				backToStart();
				autoCounter = 0;
				if (autoStep === 1) slideBook();
			}
			else {
				if (autoCounter % 2 === 1) slideBook();
				else {
					addFlipped(innerPages[autoCounter]);
					if (autoStep === 1) slideBook();
				}
				autoTimer = setTimeout(autoTransition, autoTimerInterval);
				markers.className = 'storybook-markers storybook-markers--' + autoCounter;
			}
		};

		let backToStart = function () {
			let timerCounter = 1;
			//Keep the first 2 inner pages flipped
			for (let i = innerPages.length - 1; i > 2; i--) {
				if (i % 2 === 1) {
					setTimeout(removeFlipped, 400 * timerCounter, innerPages[i]);
					timerCounter++;
				}
			}
			setTimeout(function () { markers.className = 'storybook-markers storybook-markers--0'; }, 400 * timerCounter);
			autoTimer = setTimeout(autoTransition, autoTimerInterval + (400 * timerCounter));
		};

		let removeFlipped = function (el) {
			el.classList.remove('flipped');
			el.previousElementSibling.classList.remove('flipped');
		};

		let addFlipped = function (el) {
			el.classList.add('flipped');
			el.nextElementSibling.classList.add('flipped');
		};

		return {
			Init: Init,
		};
	}());

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", gbg.StoryBook.Init);
	} else {
		gbg.StoryBook.Init();
	}

})();